import { render, staticRenderFns } from "./SecondaryLink.vue?vue&type=template&id=48ffa535&"
import script from "./SecondaryLink.vue?vue&type=script&lang=js&"
export * from "./SecondaryLink.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports